import styled from "styled-components";
import { theme } from "theme";

interface FlexContainerProps {
  $column?: boolean;
  $gap?: number;
  $fullwidth?: boolean;
  $align?: "center" | "flex-start" | "flex-end" | "stretch";
  $justify?: "center" | "flex-start" | "flex-end" | "space-between";
  $padding?: string;
  $grow?: number;
  $margin?: string;
  $cursor?: "pointer";
  $width?: string;
  $height?: string;
  $wrap?: boolean;
}

export const FlexContainer = styled.div<FlexContainerProps>`
  display: flex;

  ${({ $align }) => $align && `align-items: ${$align};`}
  ${({ $justify }) => $justify && `justify-content: ${$justify};`}
  ${({ $column }) => $column && `flex-direction: column;`}
  ${({ $gap }) => $gap && `gap: ${$gap}px;`}
  ${({ $fullwidth }) => $fullwidth && `width: 100%;`}
  ${({ $padding }) => $padding && `padding: ${$padding};`}
  ${({ $margin }) => $margin && `margin: ${$margin};`}
  ${({ $grow }) => $grow && `flex-grow: ${$grow};`}
  ${({ $width }) => $width && `width: ${$width};`}
  ${({ $height }) => $height && `height: ${$height};`}
  ${({ $cursor }) => $cursor && `cursor: ${$cursor};`}
  ${({ $wrap }) => $wrap && `flex-wrap: wrap;`}
`;

export const ContentBox = styled(FlexContainer)`
  width: 100%;
  background: ${theme.color.white};
  box-shadow: ${theme.shadow.table};
  border-radius: ${theme.borderRadius.base};
  gap: 24px;
  padding: 24px;
`;

export const PageHeadingContainer = styled(FlexContainer)`
  justify-content: space-between;
  align-items: center;
`;

export const PageTitleContainer = styled(FlexContainer)`
  align-items: flex-start;
`;

export const PageButtonsContainer = styled(FlexContainer)`
  gap: 10px;
  flex-wrap: wrap;
`;

export const InputsGridContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: ${theme.breakpoints.m}) {
    grid-template-columns: 1fr;
  }
`;

export const PageWrapper = styled(FlexContainer)`
  min-height: 100%;
`;

export const IconRoundedContainer = styled(FlexContainer)<{
  $bgColor?: string;
}>`
  border-radius: 50%;
  background: ${props => props.$bgColor || theme.color.background.gray};
  padding: 8px;
`;

export const StyledAvatarPlaceholder = styled.div`
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  min-height: 28px;
  min-width: 28px;
  width: 28px;
  background-color: #fa8545;
  color: ${theme.color.white};
  font-size: ${theme.fontSize.md};
  font-weight: ${theme.fontWeight.regular};
  line-height: ${theme.lineHeight.md};
`;

export const StyledAvatarImage = styled.img`
  border-radius: 50%;
  height: 28px;
  width: 28px;
  min-height: 28px;
  min-width: 28px;
  object-fit: cover;
  display: block;
`;

export const HorizontalDevider = styled.div`
  height: 1px;
  background: ${theme.color.borderLight};
`;

export const SummaryItemsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 16px;

  @media screen and (max-width: 1240px) {
    grid-template-columns: 1fr;
  }
`;
